
import { ImageLayerData } from "../layers/imageLayerData.model.tsx";
import { BaseSerializer } from "./baseSerializer.ts";

export class ImageSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    this._normalizeSource(data);
    const gp = new ImageLayerData(data);
    return gp;
  }
}
